export default __webpack_public_path__ + "static/media/yellowArrowUpFull.4bb3db9d.svg";